// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__28YQb","containerItemsCenter":"Skeleton_containerItemsCenter__2w7tb"};